'use client'

import { useEffect } from 'react'
import { MARTINI_BAR_REF_CODE, storeReferralCode } from '@/lib/signupAccessStorage'

/** Opening /bar lets the visitor sign up without an invite code (same as a /m/ share). */
export function BarSignupAccess() {
  useEffect(() => {
    storeReferralCode(MARTINI_BAR_REF_CODE)
  }, [])
  return null
}
